var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.005.94L.945 0l11.562 11.56-.94.94z","key":0}),React.createElement("path",{"d":"M.002 22.298l11.562-11.562.94.94L.943 23.239z","key":1})]);
}

ChevronRight.defaultProps = {"viewBox":"0 0 12.5 23.24"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
